export default "__VITE_ASSET__CSy6TlAY__"